<div class="email-dialog">
    <div class="email-header">
        <h2 mat-dialog-title>View email</h2>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="email-content">
        <!-- Email Meta Information -->
        <div class="email-meta-section">
            <div class="meta-row">
                <span class="meta-label">Subject:</span>
                <span class="meta-value">{{ data.email.subject }}</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">From:</span>
                <span class="meta-value">{{ data.email.senderName }} &lt;{{ data.email.senderEmail }}&gt;</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">To:</span>
                <span class="meta-value">{{ data.email.recipientName }} &lt;{{ data.email.recipientEmail }}&gt;</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">Applicant:</span>
                <span class="meta-value">{{ getApplicantDisplay(data.email.applicant) }}</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">Date:</span>
                <span class="meta-value">{{ DateUtil.formatDate(data.email.createdAt) }}</span>
            </div>
        </div>

        <!-- Email Content -->
        <div class="email-body-section">
            <div class="email-body-content" [innerHTML]="safeHtmlContent"></div>
        </div>
    </mat-dialog-content>
</div>
